import { useApi, configApiRef } from '@backstage/core-plugin-api';

function useScaffolder() {
  const config = useApi(configApiRef);
  const scaffolder = config.getOptionalConfig("scaffolder.providers");
  if (!scaffolder) return {};
  const gitlabScaffolder = scaffolder.getOptional("gitlab") || [];
  const githubScaffolder = scaffolder.getOptional("github") || [];
  return {
    gitlabScaffolderExists: scaffolder.has("gitlab"),
    gitlabHostScaffolder: gitlabScaffolder[0]?.host,
    gitlabTokenScaffolder: gitlabScaffolder[0]?.token,
    githubScaffolderExists: scaffolder.has("github"),
    githubHostScaffolder: githubScaffolder[0]?.host,
    githubTokenScaffolder: githubScaffolder[0]?.token
  };
}

export { useScaffolder };
//# sourceMappingURL=useScaffolder.esm.js.map
